import { render, staticRenderFns } from "./IconSvgWrench2.vue?vue&type=template&id=b5ab8be6&scoped=true&"
import script from "./IconSvgWrench2.vue?vue&type=script&lang=js&"
export * from "./IconSvgWrench2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ab8be6",
  null
  
)

export default component.exports